import { gql } from '@apollo/client';

export const CheckPPTranslationQuery = gql`
    query CheckPPTranslation($pk: String!, $majorVersion: Int!, $language: String!) {
        listSubscriberPPs(
            pk: $pk
            filter: { majorVersion: { eq: $majorVersion }, language: { eq: $language }, isDeleted: { eq: 0 } }
            limit: 1
        ) {
            items {
                pk
                sk
                language
                majorVersion
                status
                versionStr
            }
        }
    }
`;

export const GetPolicyQuery = gql`
    query GetSubPP($pk: String!, $sk: String!) {
        getSubscriberPP(pk: $pk, sk: $sk) {
            pk
            sk
            title
            content
            language
            majorVersion
            version
            isDeleted
            versionStr
            updatedAt
            updatedBy
            updatedByName {
                firstName
                lastName
                username
            }
        }
    }
`;
